<script setup lang="ts">
import type { PrimitiveProps } from 'reka-ui'
import type { HTMLAttributes } from 'vue'

import { reactiveOmit } from '@vueuse/core'
import { cn } from '~ds/lib/utils'
import { Primitive } from 'reka-ui'

import type { HeadingVariants } from '.'

import { headingVariants } from '.'

const props = withDefaults(defineProps<PrimitiveProps & {
  size?: HeadingVariants['size'];
  weight?: HeadingVariants['weight'];
  class?: HTMLAttributes['class'];
}>(), {
  as: 'h2',
})

const delegatedProps = reactiveOmit(props, 'class', 'size', 'weight')
</script>

<template>
  <Primitive
    data-slot="heading"
    :class="cn(headingVariants({ size, weight }), props.class)"
    v-bind="delegatedProps"
  >
    <slot />
  </Primitive>
</template>
